import * as React from "react";
const OfflineRatingView = React.lazy(() => import("./OfflineRatingViewContainer"));

export { OfflineRatingView };
